import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps, Redirect } from 'react-router-dom';
import { Table, Button, Modal } from 'antd';
import 'antd/dist/antd.css';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTools } from '@fortawesome/free-solid-svg-icons';
import { getEcole, getEcoles, reset, resetSchool } from './ecole.reducer';
import { Storage } from 'react-jhipster';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { FaSync } from 'react-icons/fa';
import { getSession } from 'app/shared/reducers/authentication';
import { AUTHORITIES } from 'app/config/constants';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { getEcoleActiveAnneeScolaire } from '../annee-scolaire/annee-scolaire.reducer';
export const Ecole = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();
  const ecoleList = useAppSelector(state => state.ecole.entities);

  useEffect(() => {
    dispatch(getSession());
    dispatch(reset());
    dispatch(getEcoles({}));
    const interval = setInterval(() => dispatch(getEcoles({})), 10000);
    return () => clearInterval(interval);
  }, []);

  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));

  const setcurrentecole = ecole => {
    Storage.session.set('currentEcole', ecole);
    Storage.session.set('currentAnneeScolaire', ecole.anneeScolaire);
    dispatch(getEcoleActiveAnneeScolaire(ecole.id));
  };

  const resetEcole = id => {
    dispatch(resetSchool(id));
  };

  const confirmResetEcole = id => {
    Modal.confirm({
      title: 'Attention',
      content: 'Êtes-vous sûr de vouloir supprimer les données de cet établissement ? Cette action est irréversible.',
      okText: 'Oui',
      okType: 'danger',
      cancelText: 'Non',
      onOk() {
        resetEcole(id);
      },
    });
  };

  const columns = [
    {
      title: 'Etablissement',
      dataIndex: ['nom', 'id', 'anneeScolaireId'],
      key: 'nom',
      render: (text, row) => (
        <Link to={`/home/${row['id']}/${row['anneeScolaireId']}`} onClick={() => setcurrentecole(row)}>
          {row['nom']}
        </Link>
      ),
    },
    {
      title: 'Adresse',
      dataIndex: 'adresse',
      key: 'adresse',
    },
    {
      title: 'Email',
      dataIndex: 'mail',
      key: 'mail',
    },
    {
      title: 'Option',
      dataIndex: 'option',
      key: 'option',
      render: (id, status) => (
        <div className="">
          <Button href={`${match.url}/${id}/details`} type="primary" data-cy="entityDetailsButton">
            <FontAwesomeIcon icon="eye" />{' '}
          </Button>
          &nbsp;
          {isAdmin && (
            <Button disabled={status === 'IN_PROGRESS'} onClick={e => confirmResetEcole(id)} type="primary" data-cy="entityDetailsButton">
              <FaSync title="reset" /> &nbsp; reset
            </Button>
          )}
          &nbsp;
          {isAdmin && (
            <Button href={`/ecole-config/${id}`} data-cy="entityParamsButton">
              <FontAwesomeIcon icon={faTools} /> &nbsp; réglages
            </Button>
          )}
        </div>
      ),
    },
  ];
  const { match } = props;

  const dataSource = ecoleList.map((ecole, i) => ({
    id: ecole.id,
    status: ecole.resetStatus,
    nom: ecole.nom,
    adresse: ecole.adresse,
    mail: ecole.email,
    option: ecole.id,
    anneeScolaireId: ecole.anneeScolaire?.id,
  }));

  return (
    <div>
      <h2 id="ecole-heading" data-cy="EcoleHeading">
        <Translate contentKey="korischoolApp.ecole.home.title">Ecoles</Translate>
        <div style={{ textAlign: 'right' }}>
          <Link
            to={`${match.url}/new`}
            className="btn jh-create-entity"
            id="jh-create-entity"
            style={{ backgroundColor: '#F28E19', color: 'white' }}
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="korischoolApp.ecole.home.createLabel">Create new Ecole</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        <Table dataSource={dataSource.reverse()} columns={columns} />
      </div>
    </div>
  );
};
export default Ecole;
